var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCommentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    d: "M12.864 3.8c2.502 0 4.766 1.029 6.406 2.69 1.643 1.667 2.658 3.968 2.658 6.51 0 1.25-.245 2.44-.69 3.526h0l.785 4.658-3.917-.678c-1.48 1.067-3.288 1.694-5.242 1.694-2.502 0-4.766-1.029-6.405-2.69C4.815 17.842 3.8 15.541 3.8 13s1.015-4.843 2.659-6.51C8.098 4.83 10.362 3.8 12.864 3.8z",
    transform: "translate(-297 -2222) translate(288 2210) translate(9 12)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(-297 -2222) translate(288 2210) translate(9 12) translate(7.5 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 1,
    r: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommentWhite);
export default __webpack_public_path__ + "static/media/ic_comment_white.5d9f8904fe4e3b3c79a6674a27052d2e.svg";
export { ForwardRef as ReactComponent };